/**
 * give descendents the ability to log
 */
var Loggeable = /** @class */ (function () {
    function Loggeable() {
    }
    /**
     * log method provided to all descending classes
     */
    Loggeable.prototype.log = function (tag, msg, data) {
        if (typeof (console) !== 'undefined') {
            // console.log.apply(console, arguments);
        }
    };
    Loggeable.prototype.mapping2keys = function (mapping) {
        var res = [];
        for (var p in mapping) {
            res.push(p);
        }
        return res;
    };
    return Loggeable;
}());
export { Loggeable };



//////////////////
// WEBPACK FOOTER
// ./src/plugins/lib/common/loggeable.cls.ts
// module id = Ey21
// module chunks = 75